<template>
    <div class="container training">
        <div class="row">
            <div class="col-12 col-lg-3 d-none d-lg-block">
                <div class="training__thumb">
                    <img v-auth-image="'/photos/'+ specialaction.thumbnail_image_id + '?thumbnail=300'" alt="" class="" v-if="specialaction.main_image_id" />
                </div>
                <p class="training__p training__category">{{ specialaction.created_at }}</p>
                <h3 class="training__name">{{ specialaction.title }}</h3>
            </div>
            <div class="col-12 col-lg-8 offset-lg-1 training__desc">
                <h1>{{ specialaction.title }}</h1>
                <img v-auth-image="'/photos/'+ specialaction.main_image_id" alt="" class="" v-if="specialaction.main_image_id" />
                <div v-html="specialaction.content"></div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'SpecialActionsComponent',
  data () {
    return {
        pending: true,
        specialaction: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/specialactions/' + to.params.id
    })
    .then(response => {
        next(vm => {
            vm.specialaction = response.data.data.specialaction
        })
    })
    .catch(error => next(false))
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/specialActions/SpecialActionsComponent.vue